import Vue from 'vue'
import VueRouter from 'vue-router'
import { getNav } from '../utils/nav'
import store from "../store/index"
import NProgress from 'nprogress' 
import 'nprogress/nprogress.css'// nprogress样式文件
// 进度条配置
NProgress.configure({     
  easing: 'ease',  // 动画方式    
  speed: 500,  // 递增进度条的速度    
  showSpinner: false, // 是否显示加载ico    
  trickleSpeed: 200, // 自动递增间隔    
  minimum: 0.3 // 初始化时的最小百分比
})
Vue.use(VueRouter)
let originpush = VueRouter.prototype.push
// 重写路由跳转方法，防止重复点击同一路由报错
VueRouter.prototype.push = function (location, resolve, reject) {
  if (resolve && reject) {
    originpush.call(this, location, resolve, reject)
  } else {
    originpush.call(this, location, () => { }, () => { })
  }
}
const routes = [
  {
    path: '/',
    redirect: "/auth",
  },
  {
    name: "auth",
    path: "/auth",
    component: () => import("../views/auth.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("../views/login.vue")
  },
  {
    path:"/home",
    name:"home",
    component:() => import("../layout/index.vue"),
    redirect:'/index',
    children:[
      {
        path: '/index',
        name: "index",
        component: () => import("../views/index.vue")
      },
      {
        path: "/systemMsg",
        name: "systemMsg",
        component: () => import("../views/systemMsg/index.vue")
      }
    ]
  },
  {
    name: "question",
    path: "/question",
    component: () => import("../views/question.vue")
  },
  {
    name: "effectAnalysis",
    path: "/effectAnalysis",
    component: () => import("../views/effectAnalysis.vue")
  },
  {
    path:"/loginFail",
    name:"loginFail",
    component:()=>import("../views/loginFail.vue")
  },
  {
    path: "/:catchAll(.*)",
    redirect: "/loginFail",
  }
]
routes[3].children.push(...getNav())
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})
// 路由前置守卫
router.beforeEach((to, from, next) => {
  if(to.query.token){
    localStorage.setItem("token", to.query.token);
  }

  if('showLayout' in to.query){
    store.state.showLayout = false;
  }
  
  // 开启进度条
  NProgress.start();
  if(to.path == "/auth"){
    if(to.query.token || !localStorage.getItem("token")){
      return next()
    }else{
      return next("/home")
    }
  }
  if(to.path == "/login"){
    if(localStorage.getItem("token")){
      return next("/home")
    }else{
      return next()
    }
  }
  store.state.show = true
  next()
})
router.afterEach((to)=>{
  store.commit("changecCurrentTaskType", to.meta.type)
  window.scrollTo(0,0)
  // 关闭进度条
  setTimeout(() => {
    NProgress.done()
  }, 500);
})
export default router
